import classNames from 'classnames';
import React from 'react'
import './SectionTitle.scss';

export const SectionTitle = ({children, className, ...props}) => {
    return (
        <h1 className={classNames('SectionTitle', className)}>{children}</h1>
    )
}
